<app-select-search-data #selectSearch
                        (itemSelectEvent)="change($event)"
                        [additionalUrlParameters]="additionalUrlParameters"
                        [noEntriesFoundLabel]="noEntryPlaceHolder"
                        [parentFormControlName]="parentFormControlName"
                        [parentFormGroup]="parentFormGroup"
                        [placeHolderLabel]="placeHolder"
                        [service]="service"
>
    <ng-template let-element='element' template-content>
        <span [innerHTML]="getLabel(element)"></span>
    </ng-template>
</app-select-search-data>

